import { Injectable, Injector } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { HttpService } from 'projects/core/src/public-api';
import { DocusignInfo } from './docusign-info';
import { DocusignEnvelope } from './docusign-envelope.ts';


@Injectable({
    providedIn: 'root',
})
export class DocusignService extends HttpService {


    constructor(
        protected injector: Injector
    ) {
        super(injector);
    }

    getEnvelopes(projectId: number): Observable<DocusignEnvelope[]> {
        return this.getData(`/docusign/list/for-project/${projectId}`, DocusignEnvelope);
    }

    getEditorUrl(projectId: number): Observable<DocusignInfo> {
        return this.getData(`/docusign/create-edit?projectId=${projectId}`, DocusignInfo);
    }

    deleteEnvelope(envelopeId: string): Observable<DocusignEnvelope[]> {
        return this.deleteData(`/docusign/delete-edit/${envelopeId}`, DocusignEnvelope);
    }

}